import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { BaseStepComponent } from "../../../base/base-step.component";
import { Helpers } from '../../../util/helpers';

@Component({
    selector: 'instrutor-etapa1',
    templateUrl: './instrutor-etapa1.component.html',
})
export class CrudInstrutorEtapa1Component extends BaseStepComponent {
    cpf: any;
    uploadedFilesTemp: any[];

    @Input() listaFormacaoAcademico: any[] = [];
    @Input() listaCursos: SelectItem[] = [];
    @Input() uploadedFiles: any[] = [];
    @Input() listaFormacaoInstrutor: any[] = [];
    @Input() isCPF: boolean;

    @Input() validateForm: any = false;
    @Output() validateFormChange = new EventEmitter<any>();
    @Output() stepObject: EventEmitter<any> = new EventEmitter<any>(true);
    registroEpcMask: any;
    isBuscou: boolean = false;

    @Output() listaFormacaoInstrutorChange = new EventEmitter<any[]>();
    @Output() uploadedFilesChange = new EventEmitter<any>();
    init() {

        this.registroEpcMask = { mask: Helpers.registroMask, keepCharPositions: true };
        if (this.uploadedFiles.length > 0) {
            this.uploadedFilesTemp = [];
            this.uploadedFiles.forEach(i => {
                i.show = true;
                this.uploadedFilesTemp.push(i);
            });
            this.uploadedFiles = [];
            this.uploadedFiles = this.uploadedFilesTemp;
        }
        this.uploadedFilesChange.emit(this.uploadedFiles);

        this.stepObject.emit(this);
        this.emitValidation(true);

    }
    selecionaArquivo(event) {
        for (const file of event.files) {
            if (file.name.match(/.pdf/) || file.name.match(/.jpg/) || file.name.match(/.png/)) {
                this.IncluirArquivo(file, this.uploadedFiles, this.uploadedFilesChange, { id_instrutor: 0, tipo: 1 })
            }
        }
    }
    buscaBack(event: any) {
        this.cpf = this.limpaCaracterEspecial(this.cadastro.get('instrutor.cpf').value);
        this.cadastro.get('instrutor.registro_profissional').reset();
        this.cadastro.get('instrutor.nome').reset();
        if (this.cpf.length == 11) {
            this.service.Obter("instrutor/pesquisarPorCpf", this.cpf).subscribe(data => {
                this.cadastro.get('instrutor.nome').setValue(data.nome);
                this.cadastro.get('instrutor.nome').disable();
                this.cadastro.get('instrutor.registro_profissional').setValue(data.numero_registro);
                this.isBuscou = true;
            }, err => super.showMsg('Busca', 'Mensagem de alerta', `${err._body}`))
        }
    }
    limpar(event: any) {
        this.cadastro.get('instrutor.cpf').reset();
        this.cadastro.get('instrutor.registro_profissional').reset();
        this.cadastro.get('instrutor.nome').reset();
        this.cadastro.get('instrutor.nome').enable();
        this.isBuscou = false;
    }

    removeElementList(value: any) {
        this.uploadedFiles.forEach((item, index) => {
            if (item.nome_arquivo === value.file.name && item.id < 1) {
                super.removeFromList(this.uploadedFiles, this.uploadedFilesChange, index, 'anexos');
            }
        })
    }

    emitValidation(isInit = false) {
        if (isInit) {
            this.validateForm = [];
        } else {
            if (this.cadastro.get('instrutor').valid && this.uploadedFiles.length > 0 && this.listaFormacaoInstrutor.length > 0) {
                this.isValid = true;
            }
            else {
                this.isValid = false;
                this.validateForm = [this.cadastro.get('instrutor')];
                if (this.uploadedFiles.length == 0) {
                    this.showMsgWarn(`<p>O anexo de arquivos é obrigatório.<br><br> Todos os comprovantes deverão ser anexados de uma só vez.</p>`);
                }
                if (this.listaFormacaoInstrutor.length == 0) {
                    this.showMsgWarn(`<p>É obrigatório ao menos uma formação acadêmica.</p>`);
                }

            }

        }

        setTimeout(() => this.validateFormChange.emit(this.validateForm), 0);
        this.isValidChange.emit(this.isValid);
    }

    salvarListaTurma(event) {
        this.addToList(this.listaFormacaoInstrutor, this.listaFormacaoInstrutorChange,
            this.cadastro, event,
            { formacao_instrutor: this.cadastro.get('formacao_instrutor').value });
        this.listaFormacaoInstrutor = this.listaFormacaoInstrutor.map(item => {
            if (item.id === null) {
                return item;
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/instrutor/crud/etapas/instrutor-etapa1.component.ts